// Module
var code = `<template> </template> `;
// Exports
module.exports = code;